module.exports = __webpack_public_path__ + "static/media/mobile.af655b58.png";